module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-04.f01baa61.png";